import axios from "axios";
import { Component } from "react";
import { connect } from "react-redux";
import urls from "../urls";
import StoreTableRow from "./itemsTr";
import { showSuccess, showError } from "../utils";
import {
  setInitialStoreItems,
  setStoreItems,
  deleteItem,
  setStoreDataLoading,
} from "../redux-state/features/storeMgmt/storeMgmtSlice";

class StoreItemsTable extends Component {
  /**
   *
   */
  constructor() {
    super();
    this.state = {};
    this.headerText = ["#", "التعيين", "العدد ", "تاريخ أخر تحديث ", ""];
  }
  componentDidMount() {
    const { faculty_id } = JSON.parse(localStorage.getItem("user"));
    this.props.setStoreDataLoading(true);
    axios
      .get(urls.getStore(faculty_id))
      .then((res) => {
        const table_data = res.data.results;
        console.log(table_data);
        this.props.setInitialStoreItems(table_data);
        this.props.setStoreItems(table_data);
        this.props.setStoreDataLoading(false);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.setStoreDataLoading(false);
      });

    // axios.post(urls.newInvoice, {
    //   supplier_id: 1,
    // });
  }
  handleDeleteItem = (uuid) => {
    // this.setState((prevState) => ({
    //   table_data: prevState.table_data.filter((item) => item.uiid !== uuid),
    // }));
    axios
      .delete(urls.deleteItemFromStore, {
        data: { uuid: uuid, faculty_id: this.props.faculty_id }, // Send the UUID in the request body
      })
      .then((response) => {
        // Handle success
        const msg = "تم حذف العنصر بنجاح ";
        showSuccess(msg); // Show success message
        this.props.deleteItem({ uuid });
        // Remove the item from the state
        // this.setState((prevState) => ({
        //   table_data: prevState.table_data.filter((item) => item.uiid !== uuid),
        // }));
      })
      .catch((err) => {
        // Handle error
        const errorMsg = "لم يتم الحذف بنجاح ";

        showError(errorMsg); // Show error message
      });
  };
  render() {
    const { table_data, loading } = this.props;
    return (
      <div>
        <table className="table align-middle table-hover">
          <thead className="table-light text-center">
            <tr style={{ fontSize: "12px" }}>
              {this.headerText.map((txt, idx) => (
                <th scope="col" key={"strore-table" + idx}>
                  {txt}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} className="text-center">
                  <div
                    className="spinner-border text-primary"
                    style={{ width: "3rem", height: "3rem" }}
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
            ) : (
              <StoreTableRow
                data={table_data}
                handleDeleteItem={this.handleDeleteItem}
                userType={this.props.userType}
              />
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapDispatchToProps = {
  setStoreItems,
  setInitialStoreItems,
  deleteItem,
  setStoreDataLoading,
};
const mapStateToProps = (state) => ({
  table_data: state.StoreState.storeItems,
  loading: state.StoreState.storeDataLoading,
  userType: state.userState.userType,
  faculty_id: state.userState.faculty_id,
});
export default connect(mapStateToProps, mapDispatchToProps)(StoreItemsTable);
